"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleContextMenu = void 0;
const typesafe_actions_1 = require("typesafe-actions");
const consts_1 = require("./consts");
// eslint-disable-next-line import/prefer-default-export
exports.toggleContextMenu = (0, typesafe_actions_1.createAction)(consts_1.CONTEXT_MENU)();
